import { Grid } from '@material-ui/core';
import Icon from '../../Icon';
import Handle from '../../Handler';
import ToolTip from '@material-ui/core/Tooltip';
import helpers from '../../../helpers';
import { nodeKeysLabel } from "../../../../../../../config/common";
import './style.css';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import NodeHelperPopup from '../../../../../dialogs/NodeHelperPopup';

const useStyles = makeStyles({
    image: {
        width: 100,
        height: 100,
        display: 'block',
        position: 'relative',
        top: 0,
        left: 0,
        marginTop: 38
    },
    label: {
        textAlign: 'center',
        display: 'block',
        fontSize: 17,
        fontFamily: 'Roboto, Helvetica',
        fontWeight: 500
    },
    labelDiv: {
        marginTop: "80px",
        pointerEvents: 'all'
    }
})


export default function ControllerExternalFunction({  props, validations, iconStyle }) {
    const nodeData = props.data != undefined ? props.data : '';
    const title = props?.data?.subType !== undefined && props?.data?.subType !== '' ? nodeKeysLabel[props?.data?.subType] : helpers.nodeKeysLabel[props.type];
    const classes = useStyles()
    const helperText = "Controller acts as a system delegate with access to all nodes in the application. It is a built-in node, and is authorized to interact with and coordinate across every node in the system."
    return (
        <Grid row id={`node-${props?.id}`}>
            {/* <ToolTip title={<>{nodeData?.label}</>} placement="bottom"> */}
                <Grid item xs={12} style={{pointerEvents: 'all'}}> 
                    <Icon icon={null} defaultIcon={'admin_controller'} className={classes.iconImage} style={iconStyle} />
                {nodeData?.showHelper && <NodeHelperPopup nodeData={nodeData} title={title} nodeId={props.id} nodeType={props.type} subType={props?.data?.subType} templateId={props?.templateId} customHelperText={helperText}/>}
                </Grid>
            {/* </ToolTip> */}
            <Grid item xs={12} className={classes.labelDiv}>
                <span className={classes.label}>{props.data.label}</span>
            </Grid>

            <Handle type="source" node="external_function" position="bottom" isValidConnection={validations('source', 'external_function')} id="bottom1" />
            <Handle type="source" node="external_function" position="left" isValidConnection={validations('source', 'external_function')} id="left" />
            <Handle type="source" node="external_function" position="right" isValidConnection={validations('source', 'external_function')} id="right" />

            {/* <Handle type="source" node="external_function" position="left" isValidConnection={validations('target', 'external_function')} id="left" />

            <Handle type="source" node="external_function" position="right" isValidConnection={validations('source', 'external_function')} id="right" /> */}

        </Grid>
    )
}